<template>
  <div>
    <Topbar></Topbar>
    <div>账户已到期，请续费</div>
    <pay-dialog :visible="true"></pay-dialog>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import PayDialog from '../components/PayDialog.vue'
import Topbar from '../components/Topbar.vue'
export default {
  components: { Topbar, PayDialog },
  setup () {
    const router = useRouter()
    const store = useStore()
    const obj =  reactive({
      windowWidth: 0,
      windowHeight: 0,
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {

    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    return{
      obj,
    }

  }
}
</script>
<style scoped>
</style>